
  <h2 mat-dialog-title>Detalles del Garantizado</h2>
  
  <mat-dialog-content>
    <div class="container py-3">
      <!-- Información principal -->
      <div class="row mb-4">
        <div class="col-12">
          <mat-card>
            <mat-card-content>
              <div class="row">
                <div class="col-md-12">
                  <p><strong>Vendedor:</strong> {{data.vendedorNombre}}</p>
                  <p><strong>Fecha Fin:</strong> {{data.garantizado.fecha_fin | date:'dd/MM/yyyy'}}</p>
                </div>
                <div class="col-md-6">
                  <p><strong>Fecha Inicio:</strong> {{data.garantizado.fecha_inicio | date:'dd/MM/yyyy'}}</p>
                  <p><strong>Valor:</strong> {{data.garantizado.valor | currency:'COP':'symbol-narrow':'1.0-0'}}</p>
                  <p><strong>Estado:</strong> {{data.garantizado.estado === 'A' ? 'Activo' : 'Inactivo'}}</p>
                </div>
              </div>
            </mat-card-content>
          </mat-card>
        </div>
      </div>

      <!-- Información de auditoría -->
      <div class="row">
        <div class="col-md-6">
          <mat-card>
            <mat-card-header>
              <mat-card-title class="fs-6">Información de Creación</mat-card-title>
            </mat-card-header>
            <mat-card-content class="pt-3">
              <p><strong>Usuario:</strong> {{data.garantizado.usuario_creacion}}</p>
              <p><strong>Fecha:</strong> {{data.garantizado.fecha_creacion | date:'dd/MM/yyyy'}}</p>
            </mat-card-content>
          </mat-card>
        </div>
        <div class="col-md-6" *ngIf="data.garantizado.usuario_modificacion">
          <mat-card>
            <mat-card-header>
              <mat-card-title class="fs-6">Última Modificación</mat-card-title>
            </mat-card-header>
            <mat-card-content class="pt-3">
              <p><strong>Usuario:</strong> {{data.garantizado.usuario_modificacion}}</p>
              <p><strong>Fecha:</strong> {{data.garantizado.fecha_modificacion | date:'dd/MM/yyyy'}}</p>
            </mat-card-content>
          </mat-card>
        </div>
      </div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Cerrar</button>
  </mat-dialog-actions>
